import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';


export default function ServiceCard({ service, handleSelectedService }) {
    const { serviceName, serviceDescription, servicePrice, serviceType, createdBy } = service;
    return (
        <CardActionArea sx={{ maxWidth: 200, height: 130 }} onClick={() => handleSelectedService(service)}>
            <div title={"Agregar " + serviceName?.toLowerCase()} placement="bottom">
            <Card sx={{ maxWidth: 200, height: 130 }}>
                <CardHeader
                    title={serviceName}
                    sx={{ padding: "4px",
                        margin: '5px 0 0px 10px',
                        '& .MuiCardHeader-title': {
                            fontSize: '1.05rem',
                            margin: 0,
                            padding: 0
                        }
                    }}
                />
                <CardContent sx={{ paddingTop: '0px' }} >
                    <div className='card-inf-container' style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', paddingTop: '3px' }}>
                        ({serviceType})
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', paddingTop: '10px' }}>
                        RD$ {servicePrice}.00
                    </Typography>
                    </div>
                </CardContent>
            </Card>
            </div>
        </CardActionArea>
    );
}
